module.exports = __webpack_public_path__ + "static/media/pokeapi-logo.a90ac398.png";